import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';
import { ToastProvider } from './src/contexts/ToastContext';
import { telemetry } from './src/utils/telemetryLogger';

// Global error handlers connected to structured telemetry
window.addEventListener('unhandledrejection', (event) => {
  telemetry.log('ERROR', 'UNHANDLED_REJECTION', `Unhandled promise rejection: ${event.reason?.message || event.reason}`, { reason: event.reason });
});

window.addEventListener('error', (event) => {
  telemetry.log('ERROR', 'GLOBAL_ERROR', `Global window error: ${event.error?.message || event.message}`, { error: event.error });
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <HashRouter>
      <ToastProvider>
        <App />
      </ToastProvider>
    </HashRouter>
  </React.StrictMode>
);